import { createSelector } from 'reselect';

import { getModuleSelector } from 'src/utils/redux';
import { RegisterCompletionState } from './types';

const moduleSelector =
    getModuleSelector<RegisterCompletionState>('registerCompletion');

export const isCompleteLoadingSelector = createSelector<any, boolean>(
    moduleSelector,
    (registerCompletionState: RegisterCompletionState) =>
        registerCompletionState?.loading,
);
